import React from 'react';
import * as S from './ErrorMessage.styles';
import * as T from './ErrorMessage.types';

const ErrorMessage = ({ children, isInputWithButton, disabled }: T.ErrorMessageType) => (
  <S.Message disabled={disabled} isInputWithButton={isInputWithButton}>
    {children}
  </S.Message>
);

export default ErrorMessage;
